<template>
    <RoleForm :menus="menus" />
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import RoleForm from "./Form.vue";

export default {
    name: "RoleCreate",
    layout: AppLayout,
    components: {
        RoleForm,
    },
    props: {
        menus: {
            type: Array,
            default: () => [],
        },
    },
}
</script>

